import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';

import DatePicker from 'material-ui-pickers/DatePicker';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

// pick utils
import moment from 'moment';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import orange from '@material-ui/core/colors/orange';

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#f99e60'
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      }
    },
    MuiPickersDay: {
      day: {
        //color: orange.A700,
      },
      selected: {
        backgroundColor: '#f99e60'
      },
      current: {
        color: orange['900']
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#f99e60'
      }
    }
  }
});

class DateComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
      style: {
        fontWeight: 'normal',
        backgroundColor: '#f9f8f6',
        borderRadius: '4px',
        height: '32px',
        width: '100%'
      }
    };
  }
  componentWillMount() {
    const rest = moment(this.props.date).utc() + this.props.dif;
    this.setState({ selectedDate: rest });
  }

  handleDateChange = date => {
    this.setState({ selectedDate: date });

    this.props.handleCustom({
      date: moment(date).utc(),
      id: this.props.id
    });

    // this.props.handleSubmit({
    //   date: moment(date).utc().format("DD-MM-YYYY"),
    //   id: this.props.id
    // });
  };
  render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MuiThemeProvider theme={materialTheme}>
          <div className="picker">
            <DatePicker
              id={this.props.id}
              data-style="date_modal"
              value={this.state.selectedDate}
              onChange={this.handleDateChange}
              style={this.state.style}
              clearable={true}
              clearLabel={'Limpiar'}
              autoOk={true}
              leftArrowIcon="<"
              rightArrowIcon=">"
              format="DD-MM-YYYY"
            />
          </div>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

export default DateComponent;



// WEBPACK FOOTER //
// ./source/client/components/common/date/date.jsx